import React from 'react';
import {MINUS_SIGN} from "../../../constants/text";
import {CombatOperator, CombatTerm} from "../CombatPanel/CombatPanel";

const DamageBonus = ({bonus}) => {
  if (bonus === 0) {
    return null;
  }

  return (
    <>
      <CombatOperator>{bonus < 0 ? MINUS_SIGN : '+'}</CombatOperator>
      <CombatTerm
        value={Math.abs(bonus)}
        icon={'/img/icons/damage.png'}
        iconAlt={'bonus'}
        color={'var(--combat-tone-ink)'}
        caption={'Бонус'}
      />
    </>
  );
};

export default DamageBonus;
